import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, ElementRef, Inject, OnInit, ViewChild, ɵɵtrustConstantResourceUrl } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, map, Subject } from 'rxjs';
import { startWith, toArray, filter } from 'rxjs/operators';

@Component({
  selector: 'app-user-modal',
  templateUrl: './user-modal.component.html',
  styleUrls: ['./user-modal.component.scss']
})
export class UserModalComponent implements OnInit {

  modalTitle: string;
  modalMessage: any;
  userForm!: FormGroup;
  phoneForm!: FormGroup;
  domainAccessForm!: FormGroup;
  domainList: any;
  phoneObj: any;

  contactList: any[] = [];
  filteredContactList: Observable<string[]> | undefined;
  contactFullList: any[] | undefined;

  contact_selected_uuid: string = '';

  roleList: any[] = [
    { id: 262144, role: "Super Admin" },
    { id: 4194304, role: "Carrier" },
    { id: 8388608, role: "Master" },
    { id: 16777216, role: "Customer" },
    { id: 1, role: "Admin" },
    { id: 8192, role: "Manager" },
    { id: 4096, role: "Finance" },
    { id: 32768, role: "Operations" },
    { id: 65536, role: "Sales" },
    { id: 256, role: "Dispatcher" },
    { id: 2, role: "Agent" },
    { id: 4, role: "Customer Care" },
    { id: 512, role: "Driver" }
  ];
  apiGroupList: string[] = [
    'Superadmin',
    'Admin',
    'Accounting',
    'Master',
    'Customer',
    'Carrier',
    'Consignee',
    'Shipper',
    'Inventory',
    'Technician',
    'Dispatcher'
  ];
  messagingList: any[] = [
    { id: 1, status: 'Enabled' },
    { id: 0, status: 'Disabled' },
  ]

  roleSum() {
    const ADMIN = 1;
    const SUPER_ADMIN = 2;
    const AGENT = 4;
    const CARRIER = 8;
    const CUSTOMER = 32;
    const CUSTOMER_CARE = 64;
    const DISPATCHER = 128;
    const DRIVER = 256;
    const FINANCE = 512;
    const MASTER = 1024;
    const OPERATIONS = 2048;
    const SALES = 4096;

    const sum = CUSTOMER_CARE + FINANCE + MASTER + OPERATIONS + SALES + SUPER_ADMIN + ADMIN;

    return sum;
  }


  constructor(
    public dialogRef: MatDialogRef<UserModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder, private http: HttpClient
  ) {
    this.modalTitle = data.data.modalTitle;
    this.modalMessage = data.data.modalMessage;
    this.phoneObj = data.data.phoneObj;
    this.userForm = this.formBuilder.group({
      shipper_company_name: [''],
      shipper_contact_uuid: [''],
      consignee_company_name: [''],
      consignee_contact_uuid: [''],
      customer_company_name: [''],
      customer_contact_uuid: [''],
      carrier_company_name: [''],
      carrier_contact_uuid: [''],
      ams_side_menu_array: [''],
      ams_side_sub_menu_array: [''],
      email: [''],
      password: [''],
      confirm_password: [''],
      role: [''],
      company: [''],
      domain: [''],
      api_username: [''],
      api_groups: [[]],
      contact: [''],
      contact_uuid: [''],
      messaging: [''],
      avatar_image: [null],
    });

    this.phoneForm = this.formBuilder.group({
      user_id: [''],
      domain: [''],
      api_key: [''],
      extensions: [''],
      active_extension: [''],
      gateway: [''],
      caller_id_name: [''],
      caller_id_number: [''],
    });

    this.domainAccessForm = this.formBuilder.group({
      domain: [''],
      api_username: [''],
      api_group: [''],
    });
  }
  ngOnInit(): void {
    const url: string = "/api/users/user_details.php";
    this.http.get<any>(url, { params: { table: 'domain_list_array', } }).subscribe(response => {
      if (response) {
        this.domainList = response;
        console.log('domain list', response);
        console.log(this.roleSum())
      }
      else {
        console.log(response);
        alert('No domains retrieved.')
      }
    });
    this.phoneForm.get('user_id')?.setValue(this.phoneObj?.id);
    this.phoneForm.get('domain')?.setValue(this.phoneObj?.phone_system_domain);
    this.phoneForm.get('api_key')?.setValue(this.phoneObj?.phone_system_api_key);
    this.phoneForm.get('extensions')?.setValue(this.phoneObj?.phone_system_extensions);
    this.phoneForm.get('active_extension')?.setValue(this.phoneObj?.phone_system_active_extension);
    this.phoneForm.get('gateway')?.setValue(this.phoneObj?.phone_system_gateway);
    this.phoneForm.get('caller_id_name')?.setValue(this.phoneObj?.phone_system_caller_id_name);
    this.phoneForm.get('caller_id_number')?.setValue(this.phoneObj?.phone_system_caller_id_number);

    //Populate the contact auto fill list when value changes
    this.userForm.get('contact')?.valueChanges.subscribe((data) => {
      const index = this.contactFullList?.findIndex((item: any) => item.label === data);
      if (index !== -1 && this.contactFullList && index !== undefined) {
        this.contact_selected_uuid = this.contactFullList[index]?.value;
        const apiGroups = this.userForm.get('api_groups')?.value || [];
        /// Check the apiGroups array and set the uuid accordingly of the specific contact type and set rest to
        if (apiGroups.includes('carrier')) {
          this.userForm.get('carrier_contact_uuid')?.setValue(this.contact_selected_uuid);
          this.userForm.get('customer_contact_uuid')?.setValue('');
          this.userForm.get('consignee_contact_uuid')?.setValue('');
          this.userForm.get('shipper_contact_uuid')?.setValue('');
        } else if (apiGroups.includes('customer')) {
          this.userForm.get('customer_contact_uuid')?.setValue(this.contact_selected_uuid);
          this.userForm.get('carrier_contact_uuid')?.setValue('');
          this.userForm.get('consignee_contact_uuid')?.setValue('');
          this.userForm.get('shipper_contact_uuid')?.setValue('');
        } else if (apiGroups.includes('consignee')) {
          this.userForm.get('consignee_contact_uuid')?.setValue(this.contact_selected_uuid);
          this.userForm.get('customer_contact_uuid')?.setValue('');
          this.userForm.get('carrier_contact_uuid')?.setValue('');
          this.userForm.get('shipper_contact_uuid')?.setValue('');
        } else if (apiGroups.includes('shipper')) {
          this.userForm.get('shipper_contact_uuid')?.setValue(this.contact_selected_uuid);
          this.userForm.get('customer_contact_uuid')?.setValue('');
          this.userForm.get('consignee_contact_uuid')?.setValue('');
          this.userForm.get('carrier_contact_uuid')?.setValue('');
        }
        // this.userForm.get('contact_uuid')?.setValue(this.contact_selected_uuid);
      }
    });


    this.filteredContactList = this.userForm.get('contact')?.valueChanges
      .pipe(
        startWith(''),
        filter(value => value.length >= 3), // Only proceed if the input length is 3 or more
        map(contactList => contactList ? this.filterContactList(contactList) : this.contactList.slice())
      );
  }

  onSelectionShipperAddress(event: any) {

  }

  createUser() {
    if (this.userForm.get('password')?.value == this.userForm.get('confirm_password')?.value) {
      const url: string = "/api/users/add_user.php";
      const postData = this.userForm.value;
      delete postData.confirm_password;
      delete postData.contact;
      console.log('submitted data', postData);
      this.http.post<any>(url, postData)
        .subscribe(response => {
          console.log('Post Response: ', response)
          this.dialogRef.close();
        })
    }
    else {
      alert('The confirm password must match the password!')
    }
  }

  updatePhoneSystem() {
    const url: string = "/api/users/phone_system_details.php";
    const postData = this.phoneForm.value;
    console.log('submitted data', postData);
    this.http.post<any>(url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response)
      })
  }

  @ViewChild('fileInput') fileInput!: ElementRef;

  selectFile() {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      console.log('Selected file:', file);
      this.userForm.patchValue({
        avatar_image: file // Update the 'file' FormControl value with the selected file
      });
    }
  }

  onEmailStoppedEditing(event: any) {
    if (this.userForm.get('email')?.value.length !== 0) {
      const existUser = this.modalMessage.find((item: any) => item.username === this.userForm.get('email')?.value);
      console.log('exist user?', existUser);
      if (existUser) {
        alert('User already existed. Please use different email.');
      }
    }
    else {
      return;
    }
  }

  getContactList(): Observable<string[]> {
    const domain = this.userForm.get('domain')?.value || '';
    const apiGroups = this.userForm.get('api_groups')?.value || [];

    // Define the contactType variable
    let contactType: string = '';

    /// Check the apiGroups array and set the contactType accordingly
    if (apiGroups.includes('carrier')) {
      contactType = '6';
    } else if (apiGroups.includes('customer')) {
      contactType = '20';
    } else if (apiGroups.includes('consignee')) {
      contactType = '5';
    } else if (apiGroups.includes('shipper')) {
      contactType = '4';
    }

    // Set up query parameters for the HTTP request
    const params = new HttpParams()
      .set('domain', domain)
      .set('contact_type', contactType);

    // Make the HTTP GET request with query parameters
    return this.http.get<any[]>('/api/users/user_contact_autocomplete.php', { params }).pipe(
      map(response => {
        if (response) {
          this.contactFullList = response;
          return response.map(item => item.label);
        } else {
          return [];
        }
      })
    );
  }

  updateContacts() {

    //Filter contact list and Initialize contact list
    this.getContactList().subscribe((data) => this.contactList = data);

  }

  filterContactList(name: string) {
    return this.contactList.filter(contactList =>
      contactList.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  closeModal() {
    this.dialogRef.close();
  }
}
